<template>
    <div class="container">
        <div class="row">
            <Menu class="col-lg-3"></Menu>
            <div class="col-lg-9">
                <b-card class="card">
                    <b-card-title>
                        <b-icon-arrow-left class="back-link" @click="onBackArrowClick"></b-icon-arrow-left>
                        Создание уведомления
                    </b-card-title>
                    <b-card-body>
                        <b-form-group
                                id="fieldset-title"
                                description=""
                                label="Заголовок уведомления"
                                label-for="input-title"
                                :invalid-feedback="title.errorMessage"
                                :state="title.errMessageState"
                        >
                            <b-form-input
                                    id="input-title"
                                    v-model="title.content"
                                    :state="title.state"
                                    size="sm"
                                    trim
                                    @input="onTitleChange"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                                id="fieldset-content"
                                description=""
                                label="Содержимое уведомления"
                                label-for="textarea-content"
                                :invalid-feedback="content.errorMessage"
                                :state="content.state"
                        >
                            <b-form-textarea
                                    id="textarea-content"
                                    v-model="content.content"
                                    rows="3"
                                    max-rows="6"
                                    :state="content.state"
                                    @input="onContentChange"
                            ></b-form-textarea>
                        </b-form-group>

                        <b-form-group
                                id="fieldset-related"
                                description=""
                                label="Связанная новостная статья"
                                label-for="textarea-content"
                        >
                            <b-form-select v-model="relatedArticle.selected" :options="relatedArticle.options"></b-form-select>
                        </b-form-group>
                        <b-form-group
                                class="container"
                                id="datetime"
                                label="Дата погашения"
                                label-for="textarea-content"
                                :invalid-feedback="expDate.errorMessage"
                                :state="expDate.state"
                        >
                            <template v-slot:label>
                                <b-form-checkbox
                                        id="checkbox-1"
                                        name="checkbox-1"
                                        value="accepted"
                                        unchecked-value="not_accepted"
                                        @change="onExpDateCheck"
                                >
                                    Дата погашения
                                </b-form-checkbox>
                            </template>
                            <div class="row">
                                <b-form-datepicker
                                        id="example-datepicker"
                                        v-model="expDate.dateValue"
                                        locale="ru"
                                        class="col-8"
                                        :disabled="!expDate.active"
                                ></b-form-datepicker>
                                <b-form-timepicker
                                        v-model="expDate.timeValue"
                                        :hour12="false"
                                        locale="ru"
                                        class="col-4"
                                        :disabled="!expDate.active"
                                ></b-form-timepicker>
                            </div>

                        </b-form-group>


                        <b-button variant="outline-primary" @click="onPublishClick" block>Опубликовать</b-button>
                        <p class="notification"><span class="red-asterisk">*</span>После публикации уведомления нельзя редактировать!</p>
                    </b-card-body>
                </b-card>

                <b-modal ref="err-modal" size="sm" hide-footer>
                    <div class="d-block text-center">
                        Ошибка сервера!
                    </div>
                    <b-button class="mt-3" variant="danger" block @click="closeModal">ОК</b-button>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import Menu from "../../common/Menu";
import moment from "moment";

export default {
    name: "NotificationsEditor",
    components: { Menu },
    created() {
        this.fetchNews();
    },
    data: () => ({
        title: {
            content: null,
            errorMessage: '',
            state: null, // null валидно, false не валидно
            errMessageState: null,
        },
        content: {
            content: null,
            errorMessage: '',
            state: null, // null валидно, false не валидно
            errMessageState: null,
        },
        relatedArticle: {
            selected: null,
            options: [
                { value: null, text: '<Статья не привязана>' },
            ],
        },
        expDate: {
            dateValue: moment().format("YYYY-MM-DD"),
            timeValue: moment().format("HH:mm"),
            active: false,
            state: null,
            errorMessage: '',
        },
        errors: {
            titleLength: 'Длинные заголовки могут быть отображены не полностью на некоторых устройствах. Рекомендуемая длина до 16 символов.',
            titleMaxLength: 'Максимальная длина заголовка 30 символов!',
            contentLength: 'Длинные сообщения могут быть отображены не полностью на некоторых устройствах. Рекомендуемая длина до 55 символов.',
            contentMaxLength: 'Максимальная длина сообщения 300 символов!',
            emptyField: 'Поле не может быть пустым!',
            timeInPast: 'Дата не может относиться к прошлому!'
        }
    }),
    methods: {
        onExpDateCheck(value) {
            this.expDate.active = value === "accepted";
        },
        onTitleChange(text) {
            if (text.length > 30) {
                this.title.errorMessage = this.errors.titleMaxLength;
                this.title.errMessageState = false;
                this.title.state = false;
            } else if (text.length > 16) {
                this.title.errorMessage = this.errors.titleLength;
                this.title.errMessageState = false;
                this.title.state = null;
            } else {
                this.title.errMessageState = null;
                this.title.state = null;
            }
        },
        onContentChange(text) {
            if (text.length > 300) {
                this.content.errorMessage = this.errors.contentMaxLength;
                this.content.errMessageState = false;
                this.content.state = false;
            } else if (text.length > 55) {
                this.content.errorMessage = this.errors.contentLength;
                this.content.errMessageState = false;
                this.content.state = false;
            } else {
                this.content.errMessageState = null;
                this.content.state = null;
            }
        },
        fetchNews() {
            this.$http.post(`${process.env.VUE_APP_API_HOST}/news`, {
                page: 0,
                pageSize: 100, // ВНИМАНИЕ! Тут получаем только 100 первых статей. Если будет бугурт от заказчика, то корень проблем тут
            })
                    .then(result => {
                        this.relatedArticle.options = [ { value: null, text: '<Статья не привязана>' }, ...result.data.data.rows.map((item) => ({
                            value: item.id,
                            text: item.title,
                        }))]
                    })
                    .catch(error => {
                        console.log(error.message);
                        this.$refs['err-modal'].show();
                    });
        },
        async sendNotificationQuery() {
            await this.$http.put(`${process.env.VUE_APP_API_HOST}/notifications`, {
                title: this.title.content,
                content: this.content.content,
                relatedArticleId: this.relatedArticle.selected ?? undefined,
                expDate: this.expDate.active ?
                        moment(`${this.expDate.dateValue} ${this.expDate.timeValue}`).toDate() :
                        undefined,
            }, {
                headers: {
                    Authorization: `JWT ${localStorage.getItem('jwt')}`
                }
            })
        },
        validate() {
            this.title.state = null;
            this.title.errMessageState = null;
            this.content.state = null;
            this.content.errMessageState = null;
            this.expDate.state = null;
            let valid = true;

            if (!this.title.content) {
                this.title.errorMessage = this.errors.emptyField;
                this.title.state = false;
                this.title.errMessageState = false;
                valid = false;
            }

            if (!this.content.content) {
                this.content.errorMessage = this.errors.emptyField;
                this.content.state = false;
                this.content.errMessageState = false;
                valid = false;
            }

            if (this.expDate.active && moment(`${this.expDate.dateValue} ${this.expDate.timeValue}`).isBefore(new Date())) {
                this.expDate.errorMessage = this.errors.timeInPast;
                this.expDate.state = false;
                valid = false;
            }

            return valid;
        },
        async onPublishClick() {
            if (!this.validate()) {
                return;
            }

            try {
                await this.sendNotificationQuery();
                await this.$router.push({ name: 'notifications' });
                return;
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        await this.refreshAuth();
                    } else {
                        this.$refs['err-modal'].show();
                        return;
                    }
                }
            }

            try {
                await this.sendNotificationQuery();
                await this.$router.push({ name: 'notifications' });
            } catch (error) {
                // Show connection error
                this.$refs['err-modal'].show();
            }
        },
        async onBackArrowClick() {
            await this.$router.push({ name: 'notifications' });
        },
        closeModal() {
            this.$refs['err-modal'].hide();
        },
    }
}
</script>

<style scoped>
    .editor {
        margin-bottom: 10px;
    }

    .back-link {
        color: black;
        cursor: pointer;
        font-size: 25px;
        padding: 3px;
        margin: 1px 10px 1px 1px;
        border-radius: 50%;
    }

    .back-link:hover {
        color: #007BFF;
        transition-duration: .5s;
    }

    .upload-file {
        margin-bottom: 10px;
    }

    .red-asterisk {
        color: red;
    }

    .notification {
        color: #585858;
    }
</style>